import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useDesignationMaster() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);

  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const saveDesignationMasterStatus = getStatus(state, apiKeys.saveDesignationMaster, '');
  const updateDesignationMasterStatus = getStatus(state, apiKeys.updateDesignationMaster, '');
  const designationMasterData = getData(state, apiKeys.designationMaster, []);
  const designationMasterStatus = getStatus(state, apiKeys.designationMaster, '');
  const designationMasterErrMsg = getErrorMessage(state, apiKeys.designationMaster, '');
  const deleteDesignationMasterStatus = getStatus(state, apiKeys.deleteDesignationMaster, '');

  const getDesignationMaster = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.designationMaster,
      method: apiMethods.GET,
      key: apiKeys.designationMaster,
      failureMsg: formatMessage({ id: "failed-to-get-designation-master" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getDesignationMaster()
  }, [dispatch, getDesignationMaster]);

  useEffect(() => {
    if (deleteDesignationMasterStatus === apiStatuses.succeeded) {
      getDesignationMaster();
    }
  }, [deleteDesignationMasterStatus, getDesignationMaster])

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.designationMaster }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);

  
  useEffect(() => {
    if (saveDesignationMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getDesignationMaster();
    } 
  }, [saveDesignationMasterStatus, closeModal, getDesignationMaster]);

  useEffect(() => {
    if (updateDesignationMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getDesignationMaster();
    } 
  }, [updateDesignationMasterStatus, closeModal, getDesignationMaster]);

  return useMemo(() => ({
    designationMasterData,
    designationMasterStatus,
    designationMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    designationMasterData,
    designationMasterStatus,
    designationMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
